import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class CaspianXXApiClientAndSurveyIdPairSearchParams extends SearchParamsBase {
  initialize() {
    this.Id = "";
    this.ClientId = "";
    this.SurveyName = "";
    this.SurveyId = "";
    this.IsActive = "";
  }

  //-------------------------------------------
  //-------- Fields for Search Panel ----------
  //-------------------------------------------

  static fieldsInSearchBox = [
    { fieldName: "Id", label: "ID", className: "col-3", type: InputTypesEnum.Number },
    { fieldName: "ClientId", label: "Client ID", className: "col-3", type: InputTypesEnum.Number },
    { fieldName: "SurveyName", label: "Survey Name", className: "col-3", type: InputTypesEnum.Text },
    { fieldName: "SurveyId", label: "Survey ID", className: "col-3", type: InputTypesEnum.Number },
    { fieldName: "IsActive", label: "Is Active", className: "col-3", type: InputTypesEnum.EmptyYesNoSelect },
  ];

  static iconName = "fa-solid fa-search";
  static saveType = "CaspianXXApiClientAndSurveyIdPairSearchParams";

  //---------------------------
}
